import {NgModule} from '@angular/core';
import {AsaxFrequencyViewComponent} from './asax-frequency-view.component';
import {FrequencyViewChartModule} from './frequency-view-chart/frequency-view-chart.module';


@NgModule({
  declarations: [
    AsaxFrequencyViewComponent
  ],
  imports: [
    FrequencyViewChartModule
  ],
  exports: [
    AsaxFrequencyViewComponent
  ]
})
export class AsaxFrequencyViewModule {
}
